"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kuromojin_1 = require("./kuromojin");
exports.getTokenizer = kuromojin_1.getTokenizer;
exports.tokenize = kuromojin_1.tokenize;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/kuromojin/lib/index.js
// module id = 1022
// module chunks = 0